// Comment unrequired stuff

// require("bootstrap/js/bootstrap-alert");
// require("bootstrap/js/bootstrap-button");
// require("bootstrap/js/bootstrap-carousel");
// require("bootstrap/js/bootstrap-collapse");
// require("bootstrap/js/bootstrap-dropdown");
// require("bootstrap/js/bootstrap-modal");
// require("bootstrap/js/bootstrap-tooltip");
// require("bootstrap/js/bootstrap-popover");
// require("bootstrap/js/bootstrap-scrollspy");
require("bootstrap/js/bootstrap-tab");
require("bootstrap/js/bootstrap-transition");
// require("bootstrap/js/bootstrap-typeahead");